import { render } from "./SetNewPasswordPage.vue?vue&type=template&id=1df6aa36"
import script from "./SetNewPasswordPage.vue?vue&type=script&lang=js"
export * from "./SetNewPasswordPage.vue?vue&type=script&lang=js"

import "@/css/SetNewPassword.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__